import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "container mb-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", null, " Alterar Dados da Conexão SMTP ", -1)
const _hoisted_3 = { class: "pt-3 pb-2 mb-3 border-bottom" }
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", null, "Nome", -1)
const _hoisted_6 = { class: "mb-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", null, "Email (nome@dominio.com)", -1)
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", null, "driver (smtp)", -1)
const _hoisted_10 = { class: "mb-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", null, "host", -1)
const _hoisted_12 = { class: "mb-3" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", null, "Porta (587)", -1)
const _hoisted_14 = { class: "mb-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", null, "Encryption (tls)", -1)
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", null, "username (nome@dominio.com)", -1)
const _hoisted_18 = { class: "mb-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", null, "password", -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-secondary mb-3" }, "Salvar", -1)
const _hoisted_21 = {
  key: 0,
  class: "col-md-12 mb-4"
}
const _hoisted_22 = {
  key: 0,
  class: "alert alert-success",
  role: "alert"
}
const _hoisted_23 = {
  key: 1,
  class: "alert alert-danger",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        class: "btn btn-sm btn-outline-secondary",
        title: "Voltar sem Salvar",
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.voltar()))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "arrow-circle-left" })
      ])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.name) = $event)),
          class: "form-control",
          name: "name"
        }, null, 512), [
          [_vModelText, $setup.data.name]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.address) = $event)),
          class: "form-control",
          name: "address"
        }, null, 512), [
          [_vModelText, $setup.data.address]
        ])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.data.driver) = $event)),
          class: "form-control",
          name: "driver"
        }, null, 512), [
          [_vModelText, $setup.data.driver]
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.data.host) = $event)),
          class: "form-control",
          name: "host"
        }, null, 512), [
          [_vModelText, $setup.data.host]
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.data.port) = $event)),
          class: "form-control",
          name: "port"
        }, null, 512), [
          [_vModelText, $setup.data.port]
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.data.encryption) = $event)),
          class: "form-control",
          name: "encryption"
        }, null, 512), [
          [_vModelText, $setup.data.encryption]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.data.username) = $event)),
          class: "form-control",
          name: "username"
        }, null, 512), [
          [_vModelText, $setup.data.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _hoisted_19,
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.data.password) = $event)),
          type: "password",
          class: "form-control",
          name: "password"
        }, null, 512), [
          [_vModelText, $setup.data.password]
        ])
      ]),
      _hoisted_20,
      ($setup.data.msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            ($setup.data.success)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true),
            ($setup.data.error)
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString($setup.data.msg), 1))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ], 32)
  ]))
}